import React from 'react';

import {
	Wrapper,
	Input,
	Bar,
	StyledCheckboxUncheckedIcon,
	StyledCheckboxCheckedIcon,
	StyledCheckboxIndeterminateIcon,
} from './styles';

const Checkbox = ({ style, className, inputRef, children, ...inputProps }) => {
	const { indeterminate } = inputProps;

	return (
		<Wrapper className={className} style={style}>
			<Input type="checkbox" {...inputProps} innerRef={inputRef} />
			<Bar>
				{!indeterminate && <StyledCheckboxCheckedIcon />}
				{!indeterminate && <StyledCheckboxUncheckedIcon />}
				{indeterminate ? <StyledCheckboxIndeterminateIcon /> : null}
				<span>{children}</span>
			</Bar>
		</Wrapper>
	);
};

export default Checkbox;
